const validatePhone = (phone: string) => {
  if (phone.length === 0) return true;
  if (phone.length < 6 || phone.length > 16) return false;

  const re = /^\+[\d\s]+$/;
  return re.test(phone);
};

export { validatePhone };
